"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelContext = exports.AdditionalContext = void 0;
const react_1 = __importDefault(require("react"));
const shared_1 = require("@alfalab/core-components/side-panel/shared");
exports.AdditionalContext = react_1.default.createContext({
    actionsHeight: 0,
    setActionsHeight: () => null,
    bodyGreed: false,
    setBodyGreed: () => null,
    platform: 'desktop',
    isMobile: false,
    isDesktop: false,
    isResponsive: true,
});
exports.SidePanelContext = shared_1.ModalContext;
